import React, { Component } from "react";

import styles from "./styles.scss";

interface MatchupTeamSelectorProps {
  onTeamSelection(isHome: boolean): void;
  homeTeamSelected: boolean;
  descriptor: string;
  homeTeam: any;
  awayTeam: any;
  className?: string;
}

interface MatchupTeamSelectorState {
  homeTeamSelected: boolean;
}
/**
 * Team selector when size of the viewport only allows single panel to be displayed
 * When a side-by-side team component (such as injury list or lineup list) is rendered on a small screen we provide
 * the user a selector to determine which team to show.  This is the row at the top of the list that allows the
 * user to select the team.
 *
 * An onTeamSelection callback is included to allow backpropagation of the team selection state and it provides if
 * the home team has been selected as a parameter.  The descriptor is included in the display to the user and is
 * provided as a prop so things such as "Injuries" or "Lineup" should be passed in along with the home and away
 * team objects.
 */
class MatchupTeamSelector extends Component<MatchupTeamSelectorProps, MatchupTeamSelectorState> {
  constructor(props: MatchupTeamSelectorProps) {
    super(props);
    this.state = { homeTeamSelected: props.homeTeamSelected };
  }

  /**
   * On team selection we update the internal state of this component and propagate the change up with the onTeamSelection callback.
   *
   * @param isHome {boolean} was the home team selected
   */
  _setTeamSelect = (isHome: boolean) => {
    const { onTeamSelection } = this.props;
    this.setState({ homeTeamSelected: isHome });
    onTeamSelection(isHome);
  };

  /**
   * The selection toggling occurs by setting a white (unselected) or blue (selected) class modifier on each div depending on which one is selected.
   */
  render() {
    const { homeTeamSelected } = this.state;
    const { homeTeam, awayTeam, descriptor, className } = this.props;
    return (
      <div className={`matchup-team-selector ${className || ""}`}>
        <div className="button-row">
          <button className={homeTeamSelected ? "white" : "blue"} onClick={() => this._setTeamSelect(false)}>
            {awayTeam.preferredAbbreviation.toUpperCase()} {descriptor}
          </button>
          <button className={homeTeamSelected ? "blue" : "white"} onClick={() => this._setTeamSelect(true)}>
            {homeTeam.preferredAbbreviation.toUpperCase()} {descriptor}
          </button>
        </div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}

export default MatchupTeamSelector;
